import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import common from 'src/styles/common.module.scss'
import styles from './styles.module.scss'

export const TextHeaderEn = () => {
    return (
        <HighlightedText
            text="SPIN THE WHEEL AND GET FREESPINS"
            highlights={[{ word: 'FREESPINS' }]}
            breakAfterWords={['WHEEL']}
            className={common.text_header}
        />
    )
}

export const TextLandEn = () => {
    return (
        <HighlightedText
            text="YOU HAVE WON 400 FREESPINS"
            highlights={[{ word: '400' }, { word: 'FREESPINS' }]}
            breakAfterWords={['WON']}
            className={styles.text_content}
        />
    )
}
